import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-requisition-activity-modal',
  templateUrl: './requisition-activity-modal.component.html'
})
export class RequisitionActivityModalComponent implements OnInit {

  modalData: any;
  public onClose: Subject<any>;

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService
  ) {
    this.onClose = new Subject();
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
  }

  closeModal() {
    this.onClose.next(null);
    this.bsModalRef.hide();
  }

}
